import { BrightStarIcon } from '@synoptic/ui-kit/icons/react/bright-star.tsx';
import { useLocation } from 'react-router';
import { paths } from '@/routes-utils/paths.ts';
import {
  CollapsibleMenuAction,
  CollapsibleMenuTrigger,
} from '@/routes/_app/sidebar/menu/menu-action/collapsible-menu-action.tsx';
import { MenuActionLink } from '@/routes/_app/sidebar/menu/menu-action/menu-action-link.tsx';
import { MenuSubActionLink } from '@/routes/_app/sidebar/menu/menu-action/menu-sub-action-link.tsx';

export const MarketplaceSubMenu = () => {
  const location = useLocation();
  const isMarketplace = location.pathname.startsWith(paths.marketplace);

  return (
    <CollapsibleMenuAction
      defaultOpen={isMarketplace}
      collapsedActionLink={
        <MenuActionLink
          icon={<BrightStarIcon />}
          to={paths.streams}
          label={'Marketplace'}
        />
      }
      trigger={
        <CollapsibleMenuTrigger
          active={isMarketplace}
          icon={<BrightStarIcon />}
          label={'Marketplace'}
        />
      }
    >
      <MenuSubActionLink to={paths.streams} label={'Data streams'} />
      <MenuSubActionLink to={paths.customStreams} label={'Custom streams'} />
      <MenuSubActionLink to={paths.streamPackages} label={'Stream packages'} />
    </CollapsibleMenuAction>
  );
};
